<script setup lang="ts">
import type { PropertyOnPage } from '@@/shared/property/api-types';

defineProps<{
  property: PropertyOnPage
  title: string
}>();

const emit = defineEmits<{
  map: []
}>();

const { surface: formatSurface, amount } = useIadFormat();
</script>

<template>
  <div>
    <PropertyTags :property />
    <p class="pt-xs pb-2xs">
      <IadTitle
        :text="amount(property.prices.main)"
        tag="strong"
        variant="large"
        class="text-secondary"
      />
      <IadTitle
        v-if="property.transactionType === 'rental'"
        tag="span"
        variant="small-semibold"
        class="before:content-['_'] text-secondary"
        :text="$t('property.price.rental.charges')"
      />
      <IadTitle
        v-if="property.isContractSigned"
        tag="span"
        variant="small-semibold"
        class="before:content-['_•_'] text-secondary"
        :text="$t(`property.tags.contract_signed`)"
      />
    </p>
    <IadTitle
      tag="h2"
      :text="title"
    />
    <IadLink
      v-if="property.location.hasMapInfo"
      class="pb-xs"
      :text="$t('property.common.see_on_map')"
      variant="colored"
      @click="emit('map')"
    />
    <ul class="flex gap-xs flex-wrap">
      <li
        v-for="room in property.rooms"
        :key="room.type"
        class="inline after:content-['_•_'] after:inline-block after:ps-[6px] last:after:content-none"
      >
        <Icon
          :name="room.icon"
          class="size-l inline-block"
        />
        {{ $t(`property.common.${room.type}_count`, { count: room.value }) }}
      </li>
      <li
        v-for="surface in property.surfaces"
        :key="surface.type"
        class="inline after:content-['_•_'] after:inline-block after:ps-[6px] last:after:content-none"
      >
        <Icon
          :name="surface.icon"
          class="size-l inline-block"
        />
        {{ $t(`property.surfaces.${surface.type}`, { surface: formatSurface(surface.value) }) }}
      </li>
    </ul>
  </div>
</template>
